import React, { memo } from 'react';
import PropTypes from 'prop-types';

import ErrorMessage from '../ErrorMessage';

const Input = ({ label, type, field, fieldState: { error, invalid } }) => (
  <div className="input-wrapper">
    <input
      {...field}
      aria-invalid={invalid}
      aria-label={label}
      placeholder={label}
      type={type}
      className={`form-control mx-auto ${invalid ? 'error' : ''}`}
    />
    {error && <ErrorMessage message={error.message} />}
  </div>
);

Input.propTypes = {
  field: PropTypes.shape().isRequired,
  fieldState: PropTypes.shape().isRequired,
  label: PropTypes.string,
  type: PropTypes.string,
};

Input.defaultProps = {
  label: null,
  type: 'text',
};

export default memo(Input);
